import React from 'react';
import PWABottomNav from './PWABottomNav';

/**
 * PWA Layout Wrapper
 * Wraps content with PWA-specific navigation and styling
 */
const PWALayout = ({ children }) => {
  return (
    <div className="pwa-layout">
      {/* Main Content */}
      <main className="pwa-content">
        {children}
      </main>
      
      {/* Bottom Navigation */}
      <PWABottomNav />
      
      {/* Safe area spacer for bottom nav */}
      <div className="h-16" />
    </div>
  );
};

export default PWALayout;
